import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { CurrencyRateFindDto, type CurrencyRateFindInterface } from '@zaoblako/shared/modules/catalog/dtos/currency-rate/currency-rate-find.dto';

import * as yup from 'yup';

/** Currency response body - DTO signature */
export interface CurrencyFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;

  // Data columns
  /** Currency name in Russian */
  name: string;
  /** Currency name in English */
  nameEnglish: string;
  /** Currency denomination (need for rate calculation) */
  denomination: number;
  /** Currency ISO-4217 numeric code */
  isoNumeric: string;
  /** Currency ISO-4217 character code */
  isoCharacter: string;
  /** Currency latest rate */
  latestRate?: CurrencyRateFindInterface;

  // Computed properties
  /** Computer currency sign */
  sign?: string;

  /** Default currency flag. Need for companies. */
  isDefault?: boolean;
}

/** Currency response body - DTO schema */
export const CurrencyFindDto = SerdeDtoClass.create<CurrencyFindInterface>(CatalogDtosKeysEnum.CURRENCY_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создана',
    serializer: yup.date()
  },
  updated: {
    label: 'Изменена',
    serializer: yup.date()
  },
  name: {
    sortable: true,
    label: 'Название на русском',
    serializer: yup.string(),
  },
  nameEnglish: {
    sortable: true,
    label: 'Название на английском',
    serializer: yup.string(),
  },
  denomination: {
    label: 'Номинал',
    serializer: yup.number(),
  },
  isoNumeric: {
    sortable: true,
    label: 'Цифровой код валюты согласно стандарту ISO-4217',
    serializer: yup.string(),
  },
  isoCharacter: {
    sortable: true,
    label: 'Символьный код валюты согласно стандарту ISO-4217',
    serializer: yup.string(),
  },
  latestRate: {
    optional: true,
    label: 'Последний курс',
    nested: CurrencyRateFindDto,
    serializer: (_, nested) => nested,
  },
  sign: {
    optional: true,
    label: 'Символ валюты',
    serializer: yup.string(),
  },
  isDefault: {
    optional: true,
    label: 'Валюта по-умолчанию',
    hint: 'Нужен и обрабатывается только в компаниях',
    serializer: yup.boolean(),
  },
});
